import React, { useState } from "react";
import { useBreakpoint } from "../../hooks/useBreakpoint";

import CollapsibleWrapper from "../../components/shared/collapsibleWrapper";
import CourseAccordion from "./courseAccordion";
import CourseModules from "./courseModules";
import CourseSDG from "./courseSDG";
import Image from "../../components/image";

import FeaturedBg from "images/article/featured-bg.png";
import BranchesBg from "images/online/branches-bg.png";

//type = "Course"; // Options: Course, Advanced
const CourseCurriculum = ({
  type = "Advanced",
  pageDetails,
  sDGIcon,
  courseBundleRelations,
  curriculumModules
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const breakpoint = useBreakpoint();

  return (
    <section className="relative flex flex-col justify-center bg-yellow-lighter/20">
      <div className="absolute w-full h-full planet:bg-gray-dark">
        <Image
          imageAlt={""}
          image={""}
          imageClass={"w-full h-full planet:hidden"}
          sourceUrl={FeaturedBg}
        />
        <Image
          imageAlt={""}
          image={""}
          imageClass={"w-full h-full hidden planet:block"}
          sourceUrl={BranchesBg}
        />
      </div>

      <div className="relative before:absolute before:w-full before:h-full before:left-0 before:top-0 before:from-white before:planet:from-gray-dark before:to-transparent before:bg-gradient-to-b before:md:bg-gradient-to-r">
        <div className="relative z-10 tab-content">
          <div className="course-curriculum md:grid grid-cols-2 md:gap-x-20 w-11/12 md:gvi-container my-12 md:my-28 mx-auto">
            <div
              className={`${
                type === "Course" ? "row-span-2" : "row-span-1"
              } col-span-1 md:mb-6 text-black-lighter planet:text-gray-generic`}
            >
              <CollapsibleWrapper
                desc={pageDetails.courseCurriculum}
                descStyle="tab-content_html"
                btnStyle="underline underline-offset-2 pt-3 md:hidden"
                visibleLength={breakpoint === "xs" ? 350 : 70}
                readMoreAdditionalStyle={"md:line-clamp-none"}
                type={"mobile-only"}
                displayFullDesc={breakpoint !== "xs"}
              />

              {curriculumModules === null && (
                <>
                  <CourseSDG
                    sDGIcon={sDGIcon}
                    containerClass={"hidden md:block"}
                  />
                </>
              )}
            </div>

            <div
              className={`${
                type === "Course" ? "row-span-1" : "row-span-2"
              } col-span-1`}
            >
              <div
                className="h2 mt-12 mb-6 text-black-lighter planet:text-white"
                dangerouslySetInnerHTML={{ __html: "Course curriculum" }}
              />

              {curriculumModules != null ? (
                <>
                  <div className="bg-black-lighter/80 planet:bg-white/10 rounded-xs">
                    <>
                      <CourseModules moduleData={curriculumModules} />
                    </>
                  </div>
                  <CourseSDG sDGIcon={sDGIcon} />
                </>
              ) : (
                <>
                  {courseBundleRelations?.map((course, index) => {
                    const courses = course.acfOnlineCourses;
                    return (
                      <CourseAccordion
                        key={index}
                        index={index}
                        currentIndex={currentIndex}
                        header={course.title}
                        setCurrentIndex={setCurrentIndex}
                      >
                        <>
                          <CourseModules
                            moduleData={courses.curriculumModules}
                          />
                        </>
                      </CourseAccordion>
                    );
                  })}
                  <CourseSDG sDGIcon={sDGIcon} containerClass={"md:hidden"} />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CourseCurriculum;
